import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { GIPHY_API_KEY } from "@/lib/constants";
import type { IGif } from "@giphy/js-types";
import {
  Grid,
  SearchBar,
  SearchContext,
  SearchContextManager,
} from "@giphy/react-components";
import { useContext } from "react";

interface GifPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onGifSelect: (gifUrl: string) => void;
}

const GifGridContent = ({
  onGifSelect,
  onClose,
}: {
  onGifSelect: (gifUrl: string) => void;
  onClose: () => void;
}) => {
  const { fetchGifs, searchKey } = useContext(SearchContext);

  const handleGifClick = (gif: IGif, e: React.SyntheticEvent) => {
    e.preventDefault();
    const gifUrl = gif.images?.original?.url || gif.url;
    if (gifUrl) {
      onGifSelect(gifUrl);
      onClose();
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <SearchBar placeholder="Search GIFs..." />

      <div className="max-h-[60vh] overflow-y-auto">
        <Grid
          key={searchKey}
          width={560}
          columns={3}
          fetchGifs={fetchGifs}
          onGifClick={handleGifClick}
          noLink={true}
        />
      </div>
    </div>
  );
};

export function GifPicker({ isOpen, onClose, onGifSelect }: GifPickerProps) {
  if (!GIPHY_API_KEY) {
    console.error("Giphy API key not configured");
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[610px]">
        <DialogHeader>
          <DialogTitle>Choose a GIF</DialogTitle>
        </DialogHeader>
        <SearchContextManager apiKey={GIPHY_API_KEY} options={{ rating: "g" }}>
          <GifGridContent onGifSelect={onGifSelect} onClose={onClose} />
        </SearchContextManager>
      </DialogContent>
    </Dialog>
  );
}
